import React, { useEffect } from "react";
import { Box, Text } from "@mantine/core";
import { Route, Switch } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../hooks";
import { doLogUsage } from "../admin/restQueries";
import { BatchJobTemplateEnum } from "./batchJobConstants";
import { fetchAndSetBatchJobsThunk, getBatchJobBoardThunk } from "./batchJobSlice";
import Bim360RevitToIfc from "./templates/Bim360RevitToIfc/Bim360RevitToIfc";
import Bim360SheetExtractor from "./templates/Bim360SheetExtractor/Bim360SheetExtractor";
import { MCApplicationsUrlEnum } from "@mcapps/shared/sharedConstants";

const BatchJobBoard: React.FC<{ batchJobId: string; template: string }> = ({ batchJobId, template }) => {
  const project = useAppSelector((state) => state.adminReducer.project);
  const activeBatchJob = useAppSelector((state) => state.batchJobReducer.activeBatchJob);
  const batchJobs = useAppSelector((state) => state.batchJobReducer.batchJobs);

  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getBatchJobBoardThunk(batchJobId));
    if (batchJobs == null) {
      dispatch(fetchAndSetBatchJobsThunk());
    }
  }, [batchJobId, template]);

  useEffect(() => {
    doLogUsage(project, MCApplicationsUrlEnum.BATCHJOB, "open");
  }, []);

  return (
    <Box p="0.5rem" h="100%" w="100%" style={{ overflow: "auto" }}>
      <Text component="h6" c="gray.6">
        Batchjob: {activeBatchJob?.template}
      </Text>
      <Switch>
        <Route
          path={`/project/${project._id}/batchjob/${BatchJobTemplateEnum.BIM360REVITTOIFC.toLowerCase()}/${batchJobId}`}
        >
          {activeBatchJob != null && <Bim360RevitToIfc />}
        </Route>
        <Route
          path={`/project/${
            project._id
          }/batchjob/${BatchJobTemplateEnum.BIM360SHEETEXTRACTOR.toLowerCase()}/${batchJobId}`}
        >
          {activeBatchJob != null && <Bim360SheetExtractor />}
        </Route>
      </Switch>
    </Box>
  );
};

export default BatchJobBoard;
